var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgChecklist(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 26,
    viewBox: "0 0 20 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_7010_30399)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.75 4H13C13 2.35938 11.6406 1 10 1C8.3125 1 7 2.35938 7 4H3.25C1.98438 4 1 5.03125 1 6.25V22.75C1 24.0156 1.98438 25 3.25 25H16.75C17.9688 25 19 24.0156 19 22.75V6.25C19 5.03125 17.9688 4 16.75 4ZM5.5 20.875C4.84375 20.875 4.375 20.4062 4.375 19.75C4.375 19.1406 4.84375 18.625 5.5 18.625C6.10938 18.625 6.625 19.1406 6.625 19.75C6.625 20.4062 6.10938 20.875 5.5 20.875ZM5.5 16.375C4.84375 16.375 4.375 15.9062 4.375 15.25C4.375 14.6406 4.84375 14.125 5.5 14.125C6.10938 14.125 6.625 14.6406 6.625 15.25C6.625 15.9062 6.10938 16.375 5.5 16.375ZM5.5 11.875C4.84375 11.875 4.375 11.4062 4.375 10.75C4.375 10.1406 4.84375 9.625 5.5 9.625C6.10938 9.625 6.625 10.1406 6.625 10.75C6.625 11.4062 6.10938 11.875 5.5 11.875ZM10 2.875C10.6094 2.875 11.125 3.39062 11.125 4C11.125 4.65625 10.6094 5.125 10 5.125C9.34375 5.125 8.875 4.65625 8.875 4C8.875 3.39062 9.34375 2.875 10 2.875ZM16 20.125C16 20.3594 15.8125 20.5 15.625 20.5H8.875C8.64062 20.5 8.5 20.3594 8.5 20.125V19.375C8.5 19.1875 8.64062 19 8.875 19H15.625C15.8125 19 16 19.1875 16 19.375V20.125ZM16 15.625C16 15.8594 15.8125 16 15.625 16H8.875C8.64062 16 8.5 15.8594 8.5 15.625V14.875C8.5 14.6875 8.64062 14.5 8.875 14.5H15.625C15.8125 14.5 16 14.6875 16 14.875V15.625ZM16 11.125C16 11.3594 15.8125 11.5 15.625 11.5H8.875C8.64062 11.5 8.5 11.3594 8.5 11.125V10.375C8.5 10.1875 8.64062 10 8.875 10H15.625C15.8125 10 16 10.1875 16 10.375V11.125Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_7010_30399",
    x: -61.5,
    y: -61.5,
    width: 143,
    height: 149,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 31.25
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.329412 0 0 0 0 0.529412 0 0 0 0.03 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_7010_30399"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_7010_30399",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChecklist);
export default __webpack_public_path__ + "static/media/checklist.5a323e2e.svg";
export { ForwardRef as ReactComponent };